// 创建文件en/index.js
const TW = {
    rejected: "已拒絕",
    my: "我的",
    today: "今天",
    this_week: "本周",
    this_month: "本月",
    last_month: "上月",
    this_year: "今年",
    number_of_people: "人數",
    amount: "金額",
    enter_username_id_to_search: "輸入用戶名ID查詢",
    team_list: "團隊列表",
    registration_time: "註冊時間",
    selling_face_value: "出售面值",
    click_for_details: "點擊詳情",
    "agent_login": "代理登入",
    'SignOut': '注销帳號',
    'Contact us': "聯絡我們",
    'Download our app': "下載我們的應用",
    'Download it from': "下載網址",
    'About Us': "關於我們",
    'Gobuy USA was founded in 2012': "Gobuy美國成立於2012年",
    'Customer service': "客戶服務",
    'frequently asked question': "常見問題",
    'Return and exchange policy': "退換貨政策",
    'Shipping and distribution': "配送與出貨",
    'Contact us by email': "透過郵箱聯絡我們",
    'Privacy Policy and Terms of Use': "隱私權政策和使用條款",
    'Privacy Policy': "隱私權政策",
    'Terms of use': "使用條款",
    'Upload credentials': "上傳憑證",
    'The withdrawal is being processed': "提現處理中",
    'Cause of failure': "失敗原因",
    'Your shopping cart is still empty': "您的購物車還是空的",
    'Log in to view the items in your cart': "登入查看購物車中的商品",
    'Browse around': "瀏覽一下",
    'Account correlation': "帳戶相關",
    'Order management': "訂單管理",
    'Payment method': "付款方式",
    'Collection address': "收款地址",
    Category: "分類",
    "MyCommission": "我的佣金",
    "Gross income": "總收入",
    "Direct commission": "直接佣金",
    "Indirect commission": "間接佣金",
    "Transfer to wallet": "轉入錢包",
    "Tip: The transfer amount must be greater than 10USDT": "提示：轉帳金額必須大於10USDT",
    "transfer": "轉帳",
    "commission": "佣金",
    "Please enter": "請輸入",
    'Old Password': "舊密碼",
    'Change password': "修改密碼",
    'Amazon GIFT CARD': "亞馬遜禮品卡",
    'High Priced Recycling': "高價回收",
    'Data': "日期",
    'congratulations': "恭喜",
    'Obtain': "獲得",
    'ThankYouForParticipating': "謝謝參與",

    // navbar"",
    Home: "首頁",
    Search: "搜尋",
    ShoppingCart: "購物車",
    Mine: "我的",

    // 首页
    // 搜索
    EnterSearchContent: "輸入搜尋內容",
    'Recent searches': "最近搜尋",
    'popular searches': "熱門搜尋",
    'Please search': "請輸入您想搜尋的關鍵字",
    'orderSearch': "輸入訂單或產品名稱進行搜尋",

    // 语言
    'Language selection': "語言選擇",

    // menu
    Brand: "品牌",
    Collect: "收藏",
    Manage: "管理",
    Order: "訂單",
    Wallet: "錢包",
    BlindBox: "盲盒",
    MenuGiftCard: "禮品卡",
    // HotSale
    HotSale: "最新消息在熱銷...",
    // tabs"",
    TodaysOffer: "平台優選",
    'Phone': "智慧型手機",
    'Smart Watch': "智慧手錶",
    'Smart bracelet': "智慧手環",

    // gobuy
    'home.gobuy.title': "驚喜正在等著您",
    'home.gobuy.periods': "盲盒輪次",
    'home.gobuy.freeze': "參與倒數計時",
    'home.gobuy.drawing': "開始倒數計時",
    'home.gobuy.buy': "參與",
    'home.gobuy.isbuy': "已參與",
    USDT: "USDT",
    'home.gobuy.jackpot': "獎金池",
    Purse: "錢包",
    Box: "盲盒",
    'GetAPrize': "獲取獎品",
    Discount: "折扣",
    when: "什麼時候",
    points: "積分",
    seconds: "秒",
    // MessageBox
    'MessageBox.Tips': "提示",
    'MessageBox.Confirm': "確認",
    'MessageBox.Cancel': "取消",
    'MessageBox.buy.box': "您確定要購買這個盲盒嗎？",
    // Toast
    'succ': "成功",
    'err': "錯誤",
    'box.succeeds': "購買成功",
    'box.frozen': "已參與",
    'box.issue': "每期只能購買一個盲盒",

    // 商品列表
    filter: "篩選",
    sales: "銷量",
    selfOP: "自營",
    noMore: "沒有更多了",
    brand: "品牌",
    confirm: "確認",
    reset: "重置",
    ComSor: "綜合排序",
    MostPop: "最受歡迎",
    HighLow: "價格從高到低",
    LowHigh: "價格從低到高",
    SalVol: "銷售量",
    NewArr: "新上架",

    // 购物车
    'cart.cart': "購物車",
    'cart.edit': "編輯",
    'cart.done': "完成",
    'home.cart.voucher': "取得優惠券",
    'home.cart.outstock': "缺貨",
    'home.cart.offshelf': "下架",
    'Only': "僅剩",
    'left': "個",
    'Promotion': "促銷",
    'cart.all': "全選",
    'cart.total': "總計",
    'cart.delete': "刪除",
    'cart.checkout': "結帳",

    // 我的
    'Direct': "直接",
    'Indirect': "間接",
    'MyOrders': "我的訂單",
    'ViewAll': "看全部",
    'Unpaid': "待付款",
    'ToShip': "待出貨",
    'ToReceive': "待收貨",
    'ToReview': "待評價",
    // 盲盒
    'MyBlindBox': "盲盒列表",
    'WaitingDraw': "等待抽獎",
    'Opened': "已開啟（領取/退回）",
    // 礼品卡
    'After sale': "售後",
    'GiftCard': "回收記錄",
    'RecycleGiftCard': "回收禮品卡",
    'Verifying': "校驗",
    'Rebuying': "正在回購",
    'Repurchased': "待打款",
    'Paid': "已打款",
    // 常用工具
    'CommonTools': "常用工具",
    'MyWallet': "我的錢包",
    'VirtualOrders': "虛擬訂單",
    'Refunds': "退款",
    'MyFriends': "我的好友",
    'ChatList': "聊天列表",
    'RealNameVerification': "實名認證",
    'MyFavorites': "我的收藏",
    'Addresses': "地址管理",
    'MyReviews': "我的評價",
    'BrowsingHistory': "瀏覽歷史",
    'Promotions': "促銷活動",
    'StoreManagement': "店舖管理",
    'BecomeASeller': "成為賣家",

    // 订单列表
    'SearchPlaceholder': "輸入訂單商品名稱進行搜尋",
    All: "全部",
    OrderNo: "訂單編號",
    items: "件",
    ShippingFee: "運費",
    'Refund in Progress': "退款中",
    'Cancel Order': "取消訂單",
    'Refund': "退款",
    'Track Shipping': "查看物流",
    'Confirm Receipt': "確認收貨",
    'Evaluate': "評價",
    'Delete': "刪除",
    'Pay': "付款",
    'MessageBox.delete.order': "您確定要刪除此訂單嗎？",
    'MessageBox.cancel.order': "您確定要取消此訂單嗎？",
    'MessageBox.receive.order': "此訂單是否已收貨？",
    // 订单详情
    'Order Details': "訂單詳情",
    'Pickup Code': "取貨碼",
    'Complaint': "投訴",
    'After-Sales': "售後",
    'Gift': "禮物",
    'Order Date': "訂單日期",
    'Used voucher worth': "使用的代金券金額",
    'CNY': "人民幣",
    'Payment Method': "支付方式",
    'Total Product Amount': "商品總金額",
    'Shipping Fee': "運費",
    'Amount Paid': "已付款金額",
    'Return': "退貨",
    // 盲盒列表
    'Pending Draw': "待抽獎",
    'Pending Unboxing': "待開啟",
    'Unboxed': "已開啟",
    'Collected': "已領取",
    'Recycled': "已兌現",
    'Unknown': "未知",
    'Claim': "領取",
    'Recycle': "回購",
    'Unbox': "開啟",
    'MessageBox.recycle.box': "您確定要回收此盲盒嗎？",
    // 盲盒详情
    'Mystery Box Details': "盲盒詳情",
    'Unopened': "未開啟",
    'box.opened': "未開啟",
    'Claimed': "已領取",
    'Confirm Claim': "確認領取",
    'MessageBox.pick.box': "您確定要提取此盲盒嗎？",
    // 盲盒提货
    'Please add address': "請新增地址",
    // 礼品卡列表
    'Face Value Total': "面額總額",
    // 礼品卡详情
    'Gift Card Details': "禮品卡詳情",
    'Card number': "卡號",
    'Activation code': "激活碼",
    'Actual recovery price': "實際回收價格",
    // 礼品卡回收
    'Gift Card Recycling': "禮品卡回收",
    'Confirm Recycling': "確認回收",
    'Please enter the card number': "請輸入卡號",
    'Please enter the activation code': "請輸入激活碼",
    'MessageBox.recycle.gift': "您確定要回收此禮品卡嗎？",

    // 我的钱包
    'My Wallet': "我的錢包",
    'Available Balance': "可用餘額",
    'Frozen Funds': "凍結資金",
    'Recharge': "儲值",
    "can": "可",
    'Withdraw': "提現",
    'Withdrawal Accounts': "提現帳戶",
    // 充值
    'Recharge Details': "儲值詳情",
    'Recharge Order No.': "儲值訂單編號",
    'Recharge Amount': "儲值金額",
    'Creation Time': "創建時間",
    'MessageBox.recharge.pop': "請輸入儲值金額",
    // 付款
    'payment': "付款",
    'Order submitted successfully, please select payment method': "訂單提交成功，請選擇付款方式",
    'Rechargeable card': "可儲值卡",
    'Please enter a hash': "請輸入哈希",
    'Immediate payment': "立即支付",
    'Wait for the file to load': "請等待文件加載",
    // 提现
    'Withdrawal Details': "提現詳情",
    'Withdrawal Amount': "提現金額",
    'Application Time': "申請時間",
    'New Application': "新申請",
    'Payment Password': "支付密碼",
    'New Payment Password': "新支付密碼",
    'Recipient Information': "收款人資訊",
    'Submit': "提交",
    'Add Recipient Account First': "請先新增收款帳戶",
    'Please bind your mobile phone or email first': "請先綁定您的手機或信箱",
    // 设置
    'Account Settings': "帳戶設定",
    'Change Login Password': "修改登入密碼",
    'Change Payment Password': "修改支付密碼",
    'Log Out': "登出",
    'Mobile': "智慧型手機",
    'Verification Code': "驗證碼",
    'Email': "信箱",
    'New Password': "新密碼",
    'Confirm Password': "確認密碼",
    'Modify': "修改",
    'Bind': "綁定",
    ' Mobile': "智慧型手機",
    ' Email': "信箱",
    // 资金详情
    'Fund Details': "資金詳情",
    'Withdrawal Account': "提現帳號",
    'Account Type': "帳戶類型",
    'USDT Address (TRC20)': "USDT地址（TRC20）",
    'Edit': "編輯",
    'Delete': "刪除",
    'Add New': "新增帳號",
    'MessageBox.delete.bank': "您確定要刪除此提現帳號嗎？",
    // 登录
    'Login': "登入",
    'Sign Up': "註冊",
    'Normal Login': "普通登入",
    'Username / Email / Phone Number': "使用者名稱/電子郵件",
    'Enter Phone Number': "請輸入手機號碼",
    'Enter Email': "請輸入電子郵件",
    'Enter SMS Code': "請輸入簡訊驗證碼",
    'Enter Password': "請輸入密碼",
    "enter_login_password_for_verification": "請輸入登入密碼驗證",
    'Forgot Password': "忘記密碼",
    'Third-party Login': "第三方登入",
    'Please complete the form': "請填寫完整的表單",
    'WeChat': "微信",
    'Weibo': "微博",
    'QQ': "QQ",
    'phone login': "手機登入",
    'Login Expired': "登入已過期",
    'Please enter your phone number first': "請先輸入手機號碼",
    'Please enter your username/email/phone number': "請輸入使用者名稱/電子郵件",
    'Please enter your password': "請輸入密碼",
    'Password must be at least 6 characters': "密碼必須至少為 6 個字符",
    'Please enter an 11-digit phone number': "請輸入 11 位手機號碼",
    'Please wait for the file to finish loading': "請等待檔案載入完成",
    'send': "傳送",
    'signUpTips': "您的個人資料將用於支援您在整個網站上的體驗，管理對您帳戶的訪問，以及我們隱私權政策中描述的其他目的。",

    // 注册
    'Sign Up': "註冊",
    'Referrer': "推薦人",
    'Invitation code': "邀請碼",
    'Invite friends': "邀請好友",
    'Username': "使用者名稱",
    'Full Name': "真實姓名",
    'Set Password': "設定密碼",
    'Confirm Password': "確認密碼",
    'Phone Number': "手機號碼",
    'Email': "電子郵件",
    'Username: 3-25 chars, letters & numbers': "使用者名稱：3-25 個字符，字母和數字",
    '6-20 digits/letters/symbols': "6-20 位數字/字母/符號",
    'By clicking sign up, you agree to': "點擊註冊即表示您同意",
    'User Agreement': "使用者協定",
    'Please check the user agreement': "請檢查用戶協議",
    'Please enter a username with 3-25 characters': "請輸入 3-25 個字元的使用者名",
    'Enter SMS Verification Code': "請輸入簡訊驗證碼",
    'Please enter your phone number': "請輸入您的手機號碼",
    'Please enter the verification code': "請輸入驗證碼",
    'Please enter a 6-digit verification code': "請輸入 6 位元驗證碼",
    'Please enter a password with 6-20 characters': "請輸入 6-20 個字元的密碼",
    'Please enter the confirm password': "請輸入確認密碼",
    'The confirm password does not match the entered password': "確認密碼與輸入的密碼不匹配",

    // 密码恢复
    'Password Recovery': "密碼恢復",
    'Forgot Password': "忘記密碼",
    'Forget.email.tips': "如果您的帳戶尚未與電子郵件號碼關聯，請聯絡平台管理員以恢復您的密碼。",

    // 通知
    'Notification Message': "通知訊息",
    'Direct Message': "私訊",
    'System Message': "系統訊息",
    'Leave a Message': "留言",

    // 配送地址
    'Delivery Address': "配送地址",
    'The store is no longer valid, please edit the delivery address again': "該店家不再有效，請重新編輯配送地址",
    'Default address': "預設位址",
    'Add address': "新增地址",
    'Edit address': "編輯地址",
    'MessageBox.delete.address': "您確定要刪除此地址嗎？",
    'name': "姓名",
    'phone': "手機號",
    'district': "區",
    'address': "地址",
    'default address': "預設位址",
    'save and use': "儲存並使用",
    'save': "儲存",
    'Please select a region': "請選擇地區",
    'Please fill in the recipient name': "請輸入收件人姓名",
    'Name must be 2-15 characters': "姓名必須為 2-15 個字符",
    'Please fill in the mobile phone number': "請輸入手機號碼",
    'Please select your location': "請選擇您的位置",
    'Please fill in the detailed address': "請填寫詳細地址",

    // 浏览历史
    'Browsing History': "瀏覽歷史",
    'Clear browsing history': "清除瀏覽記錄",

    // 推广会员
    'Promotion member': "推廣會員",
    "“PromotionPoster”": "推廣海報",
    "MemberName": "會員姓名",
    "MyAssets": "我的資產",
    "DistributedAmount": "分配金額",
    "NumberOfDistributedProducts": "分配產品數量",
    "DistributedProductAmount": "分配金額",
    "MyTeam": "我的團隊",
    "LevelOneMembers": "一級成員",
    "LevelTwoMembers": "二級成員",
    "PromotionPoster": "推廣海報",
    "PromotionMembers": "推廣會員",
    "PromotionPerformance": "推廣績效",
    "ViewPromotionLink": "點擊查看推廣連結",
    "PromoteViaWeChatQRCode": "透過微信二維碼推廣",
    "Copy": "複製",
    "BrowserNotSupportedCopyManually": "您的瀏覽器不支援直接複製，請手動複製",
    "GiftCardRecoveryTotal": "禮品卡回收總數",
    "TodaysGiftCardRecoveryCount": "今天的禮品卡回收數量",
    "RegistrationDate": "註冊日期",
    "LastLogin": "最後登入",
    "Promotion Commission": "推廣佣金",

    // userinfo 个人信息
    "Personal Info": "個人資訊",
    "Nickname": "暱稱",
    "Birthdate": "出生日期",
    "Save": "儲存",
    "CropImage": "裁切圖片",
    "UseImage": "使用圖片",

    // goodsDetail 商品详情
    "Off": "折扣",
    "Sold": "已售",
    "Product": "產品",
    "Comment": "評論",
    "Details": "詳情",
    "ReportViolation": "檢舉",
    "Cart": "購物車",
    "ChatMessages": "聊天訊息",
    "MyShop": "我的商店",
    "MerchantLogin": "商家登入",
    "Share": "分享",
    "ShareTo": "分享至",
    "WeChat": "微信",
    "Copy": "複製",
    "Poster": "海報",
    "BrowserNotSupportedCopyManually": "您的瀏覽器不支援直接複製，請手動複製",
    "Follow": "關注",
    "Unfollow": "取消追蹤",
    "PleaseSelectQuantityAndCategory": "請選定數量和類別。",
    "SelectedWithQuantity1": "已選{specification}，數量{number}。",
    "SelectedQuantity1": "已選數量{number}。",
    "SelectedWithQuantity2": "已選{specification}，數量{number}。",
    "Add to cart": "加入購物車",
    "Buy now": "立即購買",
    "Stock": "庫存",
    "Pieces": "件",
    "Quantity": "數量",
    "All": "全部",
    "Good": "好評",
    "Medium": "中評",
    "Bad": "差評",
    // 评论
    "Product review": "商品評論",
    "anonymous": "匿名",
    "noReviewInfo": "沒有提供評論訊息",
    "Shop Owners Response": "店主回應",
    "This product has no current reviews": "該產品目前沒有評論",
    "Product details": "產品詳情",
    "shop": "商店",
    "customerService": "客戶服務",
    "shoppingCart": "購物車",
    "addToCart": "加入購物車",
    "buyNow": "立即購買",
    "outOfStock": "所選商品目前缺貨，抱歉！",
    "notAvailable": "所選產品不再供應，抱歉！",
    "Store order message": "店舖訂單消息",
    "Confirm the order": "確認訂單",
    "productAmount": "產品金額",
    "discount": "折扣",
    "shippingFee": "運費",
    "subtotal": "店鋪小計",
    "Submit an order": "提交訂單",
    // 退货
    "refundAdd": "添加退款",
    "back": "返回",
    "refundDescription": "退款說明：",
    "proofOfRefund": "退款憑證",
    "use": "使用",
}
export default TW
